import codedesignLogo from "../assets/codedesign-logo.svg";

const dev = {
  frontendAPIUrl: "https://production-api.codedesign.ai",
  codedesignIconURL: codedesignLogo,
  frontendUrl: "https://dev.cdsn.me",
  frontendAuthenticationUrl: "https://accounts.cdsn.me",
  cache: true,
  env: "development",
};

const prod = {
  apiUrl: "https://production-api.codedesign.ai/",
  authenticationUrl: "https://production-api.codedesign.ai/",
  frontendAuthenticationUrl: "https://accounts.codedesign.ai",
  frontendUrl: "https://dashboard.codedesign.ai",
  frontendAPIUrl: "https://production-api.codedesign.ai",
  codedesignIconURL: codedesignLogo,
  cloudinaryApiUrl: "https://res.cloudinary.com/storylens",
  CLOUDINARY_UPLOAD_PRESET: "storylens-preset",
  ClOUD_NAME: "storylens",
  CLOUDINARY_UPLOAD_URL:
    "https://api.cloudinary.com/v1_1/storylens/image/upload",
  cache: false,
  env: "production",
};

const getConfig = () => {
  const environment = process.env.REACT_APP_ENV;

  if (environment === "production") {
    return prod;
  } else {
    return dev;
  }
};

// destructuring the config object
export const environmentURLs = { ...getConfig() };
